import { TooltipPositions } from "@flightpath/coreui/dist/ui/Tooltip";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IF } from "../../../components/hoc/If";
import { Panel } from "../../../components/ui/Panel";
import { Tooltip } from "../../../components/ui/Tooltip";
import { IUiAction } from "../../../core/uiAction/IUiAction";
import { UiActionComponent } from "../../../core/uiAction/UiAction";
import { Animations } from "../../../core/util/Animations";
import { useCurrentOrganisationId } from "../../../services/local/organisationContext/OrganisationContextModel";
import { ChangeNavItemsConfig, DashboardsItemsConfig, ProjectNavItemsConfig, NavIconsConfig } from "./SideNav_config";
import React from "react";
import { useGetProgrammeByProjectId } from "../../../contexts/permissions/PermissionHooks";
import PermissionsContext from "../../../contexts/permissions/PermissionsContext";
import { Hr } from "../../../components/ui/Hr";
import { Colours } from "@flightpath/coreui/dist/ui/hr";

export const DashboardNavItems: React.FC<{ isExpanded: boolean }> = ({ isExpanded }) => {
  const [isProgramme, setIsProgramme] = useState(false);

  const organisationId = useCurrentOrganisationId();
  const { projectId, programmeId } = useParams();
  const path = useLocation().pathname;

  const currentProgramme = useGetProgrammeByProjectId(organisationId, Number(projectId));
  let getProgrammeId = programmeId || currentProgramme?.id;
  let programme = null;
  if (!!getProgrammeId) {
    programme = PermissionsContext.getProgramme(organisationId, Number(getProgrammeId));
  }

  useEffect(() => {
    setIsProgramme(!!programme);
  }, [programme]);

  let dashboards = DashboardsItemsConfig(organisationId, currentProgramme?.id || programmeId, projectId, isProgramme);

  return (
    <div className="side-nav__items--dashboard">
      {dashboards.map((item, index) => {
        return (
          <SideNavItem
            isExpanded={isExpanded}
            key={index}
            item={item}
            active={path.includes(item.componentProps.href.replace("/heatmap/business-areas", ""))}
          />
        );
      })}
    </div>
  );
};

export const ProjectNavItems = isExpanded => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams();
  const [currentView, setCurrentView] = useState<"" | "change" | "training" | "processes" | "surveys">();
  const projectNavItems = ProjectNavItemsConfig(setCurrentView, organisationId, projectId, currentView);
  const pathName = useLocation().pathname;

  const navs = {
    change: DynamicNavItems(ChangeNavItemsConfig)
  };

  return projectNavItems.map((item, index) => {
    return (
      <React.Fragment key={index}>
        <SideNavItem isExpanded={isExpanded} key={index} item={item} active={pathName.includes(item.id)} />
        <IF condition={currentView === item.id}>
          <Hr style={{ width: "100%" }} colour={Colours.GRAY_400} />
        </IF>
        <IF condition={currentView === item.id}>{React.createElement(navs[item.id], { isExpanded })}</IF>
      </React.Fragment>
    );
  });
};

export const DynamicNavItems =
  (config: (organisationId, programmeId, projectId) => IUiAction<any>[]) =>
  ({ isExpanded }: { isExpanded: boolean }) =>
    <DynamicNavItem config={config} isExpanded={isExpanded} />;

const DynamicNavItem: React.FC<{ config; isExpanded: boolean }> = ({ config, isExpanded }) => {
  const path = useLocation().pathname;
  const organisationId = useCurrentOrganisationId();
  const { projectId, programmeId } = useParams();
  const projects = config(organisationId, programmeId, projectId);

  return projects.map((item, index) => {
    return (
      <SideNavItem
        isExpanded={isExpanded}
        key={index}
        item={item}
        active={path === item.componentProps.href || path.includes(item.isActiveOnAllTabs)}
      />
    );
  });
};

const SideNavItem: React.FC<{ item: IUiAction<any>; active: boolean; isExpanded: boolean }> = ({
  item,
  active,
  isExpanded
}) => {
  const icon = NavIconsConfig(active);

  const iconMap = Object.fromEntries(icon.map(i => [i.id, i.icon]));

  const sideNavItem = {
    ...item,
    componentProps: {
      ...item.componentProps,
      symbol: iconMap[item.id]
    }
  };

  return (
    <div className={`side-nav__item${active ? "--active" : ""}`}>
      {isExpanded ? (
        <>
          <UiActionComponent action={sideNavItem} />
        </>
      ) : (
        <Tooltip
          triggeredOn="hover"
          position={TooltipPositions.RIGHT}
          shownElement={<UiActionComponent action={sideNavItem} />}
        >
          <Panel.Panel
            hasBorderRadius={true}
            background={Panel.PanelBackgrounds.BG_WHITE}
            hasShadow={true}
            className={`p-2 ${Animations.FADE_IN} speed-3`}
          >
            <p className="text-dark mb-0">{item.label as string}</p>
          </Panel.Panel>
        </Tooltip>
      )}
      {`${sideNavItem.id}` === "readiness" ? <Hr style={{ width: "100%" }} colour={Colours.GRAY_400} /> : ""}
    </div>
  );
};
